import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { applyTheme, DEFAULT_THEME } from "@/lib/themes";

// Componente headless: applica il tema utente all'avvio e ad ogni cambio user.
// Deve essere montato una sola volta (dentro AuthProvider).
export default function ThemeApplier() {
  const { user } = useAuth();
  useEffect(() => {
    applyTheme(user?.theme || DEFAULT_THEME);
  }, [user?.theme, user?.id]);
  return null;
}
